import { axiosInstance } from '~/services';

import type { TypeGetOwnerManagerListResponse } from '~/types/vender.types';

/**
 * [화주사정보관리 > 화주사정보] 화주사 담당자 목록 조회
 */
const useGetOwnerManagerList = () => {
  const endPoint = '/api-owner/owner-manager/list';

  const getOwnerManagerList = async () => {
    return axiosInstance
      .get<TypeGetOwnerManagerListResponse>(endPoint)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerManagerList };
};

export default useGetOwnerManagerList;
